import { useCallback, useEffect, useRef } from 'react';

import { Size as ScreenSize } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';

const useBetSlipMaxHeight = <C extends HTMLElement = HTMLDivElement>() => {
  const betSlipRef = useRef<C>(null);
  const animationFrameRequested = useRef(false);
  const { greaterThan } = useScreenSize();
  const isMobile = !greaterThan(ScreenSize.Small);

  const calculateHeight = useCallback(() => {
    if (betSlipRef.current && !animationFrameRequested.current) {
      const { top } = betSlipRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      animationFrameRequested.current = true;
      requestAnimationFrame(() => {
        animationFrameRequested.current = false;
        betSlipRef.current?.style.setProperty('--max-bet-slip-height', `${windowHeight - top}px`);
      });
    }
  }, []);

  useEffect(() => {
    if (!isMobile) {
      window.addEventListener('scroll', calculateHeight);
      window.addEventListener('resize', calculateHeight);

      return () => {
        window.removeEventListener('scroll', calculateHeight);
        window.removeEventListener('resize', calculateHeight);
      };
    }
  }, [isMobile, calculateHeight]);

  useEffect(() => {
    if (!isMobile) {
      calculateHeight();
    }
  }, [isMobile, calculateHeight]);

  return { betSlipRef };
};

export default useBetSlipMaxHeight;
